import _ from 'underscore';
import { DS } from 'js-data';
import Promise from 'bluebird';
import mockData from './dummy-data.json';

class CustomerAdapter {
  // All of the methods shown here must return a promise

  // "definition" is a resource defintion that would
  // be returned by DS#defineResource

  // "options" would be the options argument that
  // was passed into the DS method that is calling
  // the adapter method

  findAll(/* definition, params, options */) {
    const result = _.clone(mockData.value);

    result.raw = mockData;
    result.totalCount = mockData['@odata.count'];

    return Promise.resolve(result);
  }
}

const store = new DS();

store.registerAdapter('ads', new CustomerAdapter(), { default: true });

export const Ads = store.defineResource({
  name: 'Ads',
  idAttribute: 'Id',
});
